import { useMemo } from 'react'
import { useDataValue, useDataChange } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, rdata) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'tab',
    path: 'selected.board_id',
  })

  let show_board = useDataValue({
    viewPath: props.viewPath,
    context: 'tab',
    path: 'selected.task_overlay.show_board',
  })

  return useMemo(() => {
    if (!rdata) return rdata
    let { assignees, patients, ...task } = rdata

    if (show_board && rdata) {
      change(rdata.board_id)
    }

    return {
      ...task,
      assignee: rdata.assignees[0],
      patient: rdata.patients[0],
    }
  }, [rdata, show_board])
}
